import { IAssetTab } from "../../components/AssetTabs";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const DEFAULT_ASSET: IAssetTab = { assetSymbol: 'EURUSD', id: Date.now().toString() };

export interface IAssetTabsState {
    activeTab: IAssetTab | null;
    isInitialized: boolean;
    tabs: IAssetTab[];
}

const initialState: IAssetTabsState = {
    activeTab: null,
    isInitialized: false,
    tabs: [],
};

export const assetTabsSlice = createSlice({
    name: 'assetTabs',
    initialState,
    reducers: {
        initAssetTabsAction(state, action: PayloadAction) {},
        initActiveTabAction(state, action: PayloadAction<IAssetTab | null>) {
        },
        setActiveTabAction(state, action: PayloadAction<IAssetTab | null>) {
            state.activeTab = action.payload;
        },
        initAddTabAction(state, action: PayloadAction<string>) {
        },
        addTabAction(state, action: PayloadAction<IAssetTab>) {
            state.tabs.push(action.payload);
        },
        setTabsAction(state, action: PayloadAction<IAssetTab[]>) {
            state.tabs = action.payload;
        },
        initDeleteTabAction(state, action: PayloadAction<string>) {},
        deleteTabAction(state, action: PayloadAction<string>) {
            state.tabs = state.tabs.filter(tab => tab.id !== action.payload);
        },
        setIsInitializedAction(state, action: PayloadAction<boolean>) {
            state.isInitialized = action.payload;
        },
        resetInitialAction() {
            return initialState;
        },
    },
});

export default assetTabsSlice.reducer;